import gsap from 'gsap'

export class Header {
  constructor() {
    this._header = document.querySelector('header')
    this._hero = document.querySelector('.s-hero')
    this._burger = document.querySelector('#burger')
    this._menu = document.querySelector('#mobile-menu')
    this._scrollValue = 0
    this._itemsWithChildren = document.querySelectorAll('.menu-item-has-children')

    if (this._hero) {
      this._heroHeight = this._hero.clientHeight
      this.scroll()
    }

    if (this._itemsWithChildren.length) {
      this._itemsWithChildren.forEach(item => {
        this.handleSubmenu(item)
      })
    }

    this._burger?.addEventListener('click', this.handleBurger)
    this._menu?.addEventListener('click', this.handleMenuClick)
    document.addEventListener('keydown', this.handleKey)
    window.addEventListener('scroll', this.scroll)
  }

  setOpen = (open) => {
    this._header?.classList.toggle('is-menu-open', open)
    document.documentElement.classList.toggle('is-menu-open', open)
    this._burger?.setAttribute('aria-expanded', String(open))
    this._burger?.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu')
    this._menu?.setAttribute('aria-hidden', String(!open))

    if (open) {
      this._lockY = window.scrollY
      window.lenis?.stop()
      document.body.style.top = `-${this._lockY}px`
    } else {
      document.body.style.top = ''
      window.scrollTo(0, this._lockY || 0)
      window.lenis?.start()
    }
  }

  handleBurger = () => {
    this.setOpen(!this._header?.classList.contains('is-menu-open'))
  }

  handleKey = (e) => {
    if (e.key === 'Escape' && this._header?.classList.contains('is-menu-open')) {
      this.setOpen(false)
      this._burger?.focus()
    }
  }

  handleMenuClick = (e) => {
    const link = e.target.closest('a')
    if (!link) return
    if (link.parentElement?.classList.contains('menu-item-has-children')) return
    this.setOpen(false)
  }

  scroll = () => {
    this._scrollValue = window.scrollY

    if (this._scrollValue > this._heroHeight) {
      this._header.classList.add('scrolled')
    } else {
      this._header.classList.remove('scrolled')
    }
  }

  handleSubmenu = (item) => {
    const submenu = item.querySelector('.sub-menu')
    const link = item.querySelector(':scope > a')
    if (!submenu || !link) return

    const openAnimation = gsap.to(submenu, {
      height: 'auto',
      duration: 0.5,
      autoAlpha: 1,
      ease: 'power2.inOut',
      paused: true,
    })

    // burger : click ; desktop : hover (pas les deux — le hover cassait le menu mobile)
    if (item.closest('.mobile-menu')) {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        item.classList.toggle('is-open')
        if (openAnimation.progress() > 0) openAnimation.reverse()
        else openAnimation.play()
      })
      return
    }

    item.addEventListener('mouseover', () => openAnimation.play())
    item.addEventListener('mouseleave', () => openAnimation.reverse())
  }

}
